/* eslint-disable */
// 本工程的上下文基础目录
window.IMPORT_CONFIGS && (window.IMPORT_CONFIGS.BASE = __webpack_public_path__ || './');
